import React from "react";

const SearchField = ({ value, onChange, onSearch, results, onSelect }) => {
  return (
    <div style={{ position: "relative", width: "250px" }}>
      <div style={{ display: "flex" }}>
        <input
          type="text"
          placeholder="Search"
          value={value}
          onChange={onChange}
          style={{
            flex: 1,
            height: "40px",
            padding: "0 10px",
            border: "1px solid #ccc",
            borderRadius: "4px 0 0 4px",
            outline: "none",
          }}
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSearch}
          style={{
            width: "80px",
            height: "52px",
            borderRadius: "0 4px 4px 0",
            marginLeft: "-20px",
          }}
        >
          Search
        </button>
      </div>

      {/* Dropdown suggestions */}
      {results && results.length > 0 && (
        <ul
          role="listbox"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ccc",
            listStyle: "none",
            margin: 0,
            padding: 0,
            maxHeight: "150px",
            overflowY: "auto",
            zIndex: 1000,
            borderRadius: "0 0 4px 4px",
          }}
        >
          {results.map((user, index) => (
            <li
              key={user.id || user.profileId || index}
              role="option"
              style={{
                padding: "8px",
                borderBottom: "1px solid #eee",
                cursor: "pointer",
              }}
              onClick={() => onSelect(user)}
            >
              {user.userName || "Unknown"}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchField;
